import { RESOLVED_IN_SLA_PROPERTY_VALUE, RESOLVED_OUTSIDE_SLA_PROPERTY_VALUE } from '../constants/enums';
const resolvedStatuses = [RESOLVED_IN_SLA_PROPERTY_VALUE, RESOLVED_OUTSIDE_SLA_PROPERTY_VALUE];
export const getIsSLAResolved = slaStatus => resolvedStatuses.includes(slaStatus);